import { Autocomplete, styled } from "@mui/material";
import { TEXT_FONT_FAMILY } from "./Variables";

const LABEL_PREFIX = "MyAutocomplete";
export const labelClasses = {
  root: `${LABEL_PREFIX}-root`,
  inputRoot: `${LABEL_PREFIX}-inputRoot`,
  option: `${LABEL_PREFIX}-option`,
  formControlRoot: `${LABEL_PREFIX}-formControlRoot`,
  inputLabelRoot: `${LABEL_PREFIX}-formControlRoot`
};

// Use the `styled` API to create the root component with custom styles
export const LabeledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`&.${labelClasses.inputRoot}`]: {
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 14,

    "&:Mui-hover .MuiAutocomplete-root": {
      border: "1px solid var(--level-5)"
    },
    "&.MuiInputBase-input::placeholder": {
      color: "var(--text-color) !important",
      opacity:1,
    },
    "&.Mui-focused .MuiAutocomplete-root": {
      border: "1px solid var(--level-5)"
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      background: "var(--disabled-color)",
      cursor: "not-allowed"
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--border-color) !important"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--level-3) !important"
    },

    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      fontSize: 12
    },

    "& .MuiSvgIcon-root ": {
      height: 16,
      width: 16
    },

    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      fontSize: "12px !important",
      fontFamily: TEXT_FONT_FAMILY
    }
  },
  [`& .${labelClasses.formControlRoot}`]: {
    fontFamily: TEXT_FONT_FAMILY,
    color: "var(--text-color)",
    borderRadius: "6px",
    fontSize: 12,
    "&.Mui-focused .MuiInputBase-formControl": {
      border: "1px solid var(--level-5)"
    },
    " &.hover": {
      border: "1px solid var(--level-5) !important"
    },

    "& label.Mui-focused": {
      color: "var(--text-color)"
    },
    "& .MuiInputBase-input": {
      height: "15px !important"
    },

    "& .MuiAutocomplete-root ": {
      padding: "0px !important"
    },

    "& .MuiOutlinedInput-root": {
      padding: "0px !important"
    }
  },
  [`& .${labelClasses.option}`]: {
    fontSize: 14,
    padding: theme.spacing(1)
  }
}));

export const requiredLabeledAutoComplete = styled(Autocomplete)(
  ({ theme }) => ({
    [`&.${labelClasses.inputRoot}`]: {
      color: "var(--text-color)",
      fontFamily: TEXT_FONT_FAMILY,
      fontSize: 14,
      padding: "6px !important",

      "&:Mui-hover .MuiAutocomplete-root": {
        border: "1px solid var(--level-5)"
      },

      "&.Mui-focused .MuiAutocomplete-root": {
        border: "1px solid var(--level-5)"
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        background: "var(--disabled-color)",
        cursor: "not-allowed"
      },

      "& .MuiOutlinedInput-notchedOutline": {
        border: "1px solid var(--border-color) !important",
        borderRight: "3px solid red !important"
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: "1px solid var(--level-3) !important"
      },

      "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
        fontSize: 12
      },

      "& .MuiSvgIcon-root ": {
        height: 16,
        width: 16
      },
      " & .MuiAutocomplete-endAdornment ": {
        backgroundColor: "var(--bg-color)"
      },
      "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
        fontSize: "12px !important",
        fontFamily: TEXT_FONT_FAMILY
      }
    }
  })
);

const FORM_PREFIX = "FormMyAutocomplete";
export const formClasses = {
  root: `${FORM_PREFIX}-root`,
  inputRoot: `${FORM_PREFIX}-inputRoot`,
  option: `${FORM_PREFIX}-option`,
  formControlRoot: `${FORM_PREFIX}-formControlRoot`,
  inputLabelRoot: `${FORM_PREFIX}-formControlRoot`
};

// Use the `styled` API to create the root component with custom styles
export const FormAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`&.${formClasses.inputRoot}`]: {
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 14,
    padding: "0px !important",

    "&.Mui-focused .MuiAutocomplete-root": {
      border: "1px solid var(--level-5)"
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      background: "var(--disabled-color) !important",
      cursor: "not-allowed"
    },
    "&.MuiInputBase-input::placeholder": {
      color: "var(--text-color) !important"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--border-color) !important"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--level-3) !important"
    },

    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      margin: -1,
      fontSize: 12
    },
    "& .MuiSvgIcon-root ": {
      height: 18,
      width: 18
    },

    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      fontSize: "12px !important",
      fontFamily: TEXT_FONT_FAMILY
    },

    "& .MuiAutocomplete-root ": {
      padding: "0px !important"
    },

    "& .MuiOutlinedInput-root": {
      padding: "0px !important"
    },

    "& .MuiChip-label": {
      fontFamily: TEXT_FONT_FAMILY,
      fontSize: " 12px !important"
    },

    "& .MuiChip-root": {
      height: " 20px !important"
    },

    "& .MuiAutocomplete-tag": {
      margin: "0px 3px !important"
    }
  },
  [`& .${formClasses.formControlRoot}`]: {
    fontFamily: TEXT_FONT_FAMILY,
    color: "var(--text-color)",
    borderRadius: "6px",
    position: "relative",
    marginTop: "10px",

    "&.Mui-focused .MuiInputBase-formControl": {
      border: "1px solid var(--level-5)"
    },
    " &.hover": {
      border: "1px solid var(--level-5)"
    },

    "& label.Mui-focused": {
      color: "var(--text-color)"
    },
    "& .MuiInputBase-input": {
      height: "15px !important",
      fontSize: 14,
      fontFamily: TEXT_FONT_FAMILY
    },
    "& .MuiAutocomplete-root ": {
      padding: "0px !important"
    },

    "& .MuiOutlinedInput-root": {
      padding: "0px !important"
    }
  }
}));

//requiredField in Form

export const RequiredAutoComplete = styled(Autocomplete)(({ theme }) => ({
  [`&.${formClasses.inputRoot}`]: {
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 14,
    boxShadow: " 3px 0px 0px red",
    width: "calc(100% - 3px) !important",
    padding: "0px !important",
    marginTop: "10px",
    borderRadius: "6px",

    "&.Mui-focused .MuiAutocomplete-root": {
      border: "1px solid var(--level-5)"
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--border-color) !important"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--level-3) !important"
    },

    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      fontSize: 12
    },
    "& .MuiSvgIcon-root ": {
      height: 18,
      width: 18
    },

    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      fontSize: 12,
      fontFamily: TEXT_FONT_FAMILY
    }
  },
  [`& .${formClasses.formControlRoot}`]: {
    fontFamily: TEXT_FONT_FAMILY,
    color: "var(--text-color)",
    position: "relative",

    "&.Mui-focused .MuiInputBase-formControl": {
      border: "1px solid var(--level-5)"
    },
    " &.hover": {
      border: "1px solid var(--level-5)"
    },

    "& label.Mui-focused": {
      color: "var(--text-color)"
    },
    "& .MuiInputBase-input": {
      height: "15px !important",
      fontSize: 14,
      fontFamily: TEXT_FONT_FAMILY
    },

    "& .MuiAutocomplete-root ": {
      padding: "0px !important"
    },

    "& .MuiOutlinedInput-root": {
      padding: "0px !important"
    }
  }
}));

//for InstDetails in Header Component
export const InstAutoCompleteStyles = styled(Autocomplete)(({ theme }) => ({
  [`&.${formClasses.inputRoot}`]: {
    color: "var(--text-color)",
    fontFamily: TEXT_FONT_FAMILY,
    fontSize: 16,
    padding: "3px !important",

    "&.Mui-focused .MuiAutocomplete-root": {
      border: "0px solid var(--level-5)"
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "0px solid var(--border-color) !important"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "0px solid var(--level-3) !important"
    },
    "& .MuiOutlinedInput-root": {
      padding: 6
    },
    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      margin: -1,
      fontSize: 14
    },
    "& .MuiSvgIcon-root ": {
      height: 18,
      width: 18
    },

    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      fontSize: "12px !important",
      fontFamily: TEXT_FONT_FAMILY
    },
    "& .MuiAutocomplete-root ": {
      padding: "7px !important"
    }
  },
  [`& .${formClasses.formControlRoot}`]: {
    fontFamily: TEXT_FONT_FAMILY,
    color: "var(--text-color)",
    borderRadius: "6px",
    position: "relative",

    "&.Mui-focused .MuiInputBase-formControl": {
      border: "1px solid var(--level-5)"
    },
    "&:hover": {
      boxShadow:
        "0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.10)"
    },

    "& label.Mui-focused": {
      color: "var(--text-color)"
    },
    "& .MuiInputBase-input": {
      fontSize: 16,
      fontFamily: TEXT_FONT_FAMILY,
      padding: " 2px !important",
      fontWeight: "700 !important"
    }
  }
}));

//Selected

export const SelectAutocomplete = styled(Autocomplete)(({ theme }) => ({
  [`&.${formClasses.inputRoot}`]: {
    color: "var(--level-6)",
    fontFamily: TEXT_FONT_FAMILY,
    border: "1px solid var(--border-color) !important",
    fontSize: 14,
    padding: "7.5px 2px 7.5px 3px",
    background: "var(--disabled-color)",

    "&:Mui-hover .MuiAutocomplete-root": {
      border: "1px solid var(--level-5) !important"
    },

    "&.Mui-focused .MuiAutocomplete-root": {
      border: "1px solid var(--level-5)"
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important"
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--level-3) !important"
    },
    "& .MuiOutlinedInput-root": {
      padding: 6
    },
    "& .MuiButtonBase-root.MuiAutocomplete-clearIndicator": {
      margin: -1,
      fontSize: 12
    },
    "& .MuiSvgIcon-root ": {
      height: 18,
      width: 18
    },
    "& .MuiAutocomplete-endAdornment": {
      background: "var(--disabled-color) !important"
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option": {
      fontSize: 12,
      fontFamily: TEXT_FONT_FAMILY
    }
  },
  [`& .${formClasses.formControlRoot}`]: {
    fontFamily: TEXT_FONT_FAMILY,
    color: "var(--text-color)",
    borderRadius: "6px",
    position: "relative",

    "&.Mui-focused .MuiInputBase-formControl": {
      border: "1px solid var(--level-5)"
    },
    " &.hover": {
      border: "1px solid var(--level-5)"
    },

    "& label.Mui-focused": {
      color: "var(--text-color)"
    },
    "& .MuiInputBase-input": {
      height: "30px !important",
      fontSize: 14,
      fontFamily: TEXT_FONT_FAMILY,
      padding: "0px 5px !important"
    }
  }
}));
